import { FIREBASE_CONFIG, handleFirebaseMessaging } from '@/helpers/firebase'
import { deleteCookie, getCookie, setCookie } from '@/helpers/props'
import { useRouter } from 'next/router'
import { Workbox } from 'workbox-window'
import { initializeApp } from 'firebase/app'
import { fetchBootstrapData } from '@/redux/store/actions/auth'
import heap from '@/helpers/heap'

export const cpos = [
  'utm_takhfifan',
  'soltan_ref_id',
  'dm-clickid',
  'mopon_clickid',
  'safarmarketId',
]

const useInitializations = dispatch => {
  const router = useRouter()

  const serviceWorker = () => {
    const app = initializeApp(FIREBASE_CONFIG)
    if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
      const wb = new Workbox(window.location.origin + '/sw.js')
      wb.register().then(registeration => {
        if (registeration)
          handleFirebaseMessaging({ dispatch, registeration, app })
      })
    }
  }

  const getUtmParams = () => {
    if (typeof window === 'undefined') return
    const params = new URL(window.location.href).searchParams

    params?.get('utm_source') &&
      sessionStorage.setItem('utm_source', params?.get('utm_source') || '')
    params?.get('utm_medium') &&
      sessionStorage.setItem('utm_medium', params?.get('utm_medium') || '')
    params?.get('utm_campaign') &&
      sessionStorage.setItem('utm_campaign', params?.get('utm_campaign') || '')
  }
  const goftino = () => {
    if (typeof window !== 'undefined') {
      ;(window as any).isGoftinoReady = true
      ;(window as any).Goftino.setWidget({
        hasIcon: false,
        counter: '#unread_counter',
      })
    }
  }

  const abnEvent = () => {
    const abn = getCookie('_abn')
    if (abn) {
      heap.track('ab_number', {
        abn: Number(abn),
      })
    }
  }

  const thirdPartyCookieByQueries = () => {
    if (typeof window !== 'undefined') {
      const queries = new URL(window.location.href).searchParams

      // IMPORTANT: Add new cpo in cpos array first
      const deleteRestCookies = ExceptionCpo => {
        cpos.forEach(cpo => {
          if (cpo !== ExceptionCpo && !!getCookie(cpo)) {
            deleteCookie(cpo)
          }
        })
      }

      // set takhfifan cookie
      if (queries?.get('tatoken')) {
        setCookie('utm_takhfifan', queries?.get('tatoken'), 30)
        deleteRestCookies('utm_takhfifan')
      }

      // set soltanesafar cookie
      if (queries?.get('soltan_ref_id')) {
        setCookie('soltan_ref_id', queries?.get('soltan_ref_id'), 7)
        deleteRestCookies('soltan_ref_id')
      }

      // set mopon cookie
      if (queries?.get('utm_source') === 'mopon') {
        setCookie('mopon_clickid', 'mopon', 7)
        deleteRestCookies('mopon_clickid')
      }

      // set dm-clickid cookie
      if (queries?.get('dm-clickid')) {
        setCookie('dm-clickid', queries?.get('dm-clickid'), 7)
        deleteRestCookies('dm-clickid')
      }

      // set safar market cookie
      if (queries?.get('safarmarketId')) {
        setCookie('safarmarketId', queries?.get('safarmarketId'), 7)
        deleteRestCookies('safarmarketId')
      }
    }
  }

  const bootstrap = (cancelCondition = false) => {
    if (cancelCondition) return
    dispatch(fetchBootstrapData())
  }

  const adtrace = () => {
    if (typeof window !== 'undefined') {
      /**
       * next router query is not usable here
       * because in static pages like home page is not stable till page completely loads
       */
      const queries = new URL(window.location.href).searchParams
      if (queries.get('gps_adid')) {
        sessionStorage.setItem('gps_adid', queries.get('gps_adid') || '')
      }
    }
  }

  const getBrowserMode = () => {
    window.dataLayer = window.dataLayer || []

    if (
      window.matchMedia &&
      window.matchMedia('(prefers-color-scheme: dark)').matches
    ) {
      window.dataLayer.push({
        event: 'user_browser_mode',
        browser_mode: 'Dark',
      })
    } else if (
      window.matchMedia &&
      window.matchMedia('(prefers-color-scheme: light)').matches
    ) {
      window.dataLayer.push({
        event: 'user_browser_mode',
        browser_mode: 'Light',
      })
    } else {
      window.dataLayer.push({
        event: 'user_browser_mode',
        browser_mode: 'No Preference',
      })
    }
  }

  return {
    serviceWorker,
    goftino,
    thirdPartyCookieByQueries,
    bootstrap,
    adtrace,
    getBrowserMode,
    getUtmParams,
    abnEvent,
  }
}

export default useInitializations
